import React from "react";
import { useDataTableContext } from "../Context/DataTableContext";
import { Button } from "@/components/ui";
import { useTranslation } from "react-i18next";

interface ControlsPaginationComponentProps {
  onNextPage?: (() => void) | boolean;
  onPreviousPage?: (() => void) | boolean;
}

export function ControlsPaginationComponent({
  onNextPage,
  onPreviousPage,
}: ControlsPaginationComponentProps) {
  const { table, isLoading } = useDataTableContext();
  const { t } = useTranslation();

  const handlePreviousPage = (): void => {
    table?.previousPage();
  };

  const handleNextPage = () => {
    table?.nextPage();
  };

  return (
    <div className="flex items-center justify-between gap-2 p-6">
      <Button
        role="button"
        variant="outline"
        className="rounded border px-4 py-2"
        onClick={(onPreviousPage as () => void) || handlePreviousPage}
        disabled={
          isLoading ||
          (onNextPage === undefined
            ? !table?.getCanPreviousPage()
            : !onPreviousPage)
        }
        aria-disabled={isLoading || !onPreviousPage}
        aria-label={t("dataTable.goToPreviousPage")}
      >
        {t("global.previous")}
      </Button>
      <Button
        role="button"
        variant="outline"
        className="rounded border px-4 py-2"
        onClick={(onNextPage as () => void) || handleNextPage}
        disabled={
          isLoading ||
          (onNextPage === undefined ? !table?.getCanNextPage() : !onNextPage)
        }
        aria-disabled={isLoading || !onNextPage}
        aria-label={t("dataTable.goToNextPage")}
      >
        {t("global.next")}
      </Button>
    </div>
  );
}
